import React from 'react'; 
import ReactPaginate from 'react-paginate';
import {
  MdKeyboardArrowLeft, MdKeyboardArrowRight,MdOutlineCircle
} from "react-icons/md"; 
import { Tooltip } from 'react-tooltip'; 


function AllMatch() {
  
  return (
    <>
    
      <div className='px-4 '>
        <div className='container-fluid p-0'>
          <div className='row'>
            <div className='d-flex align-items-center justify-content-between '>
              <h4 className='header-title pb-3  mt-4'> 
                Live Match
              </h4> 
            </div>
            <div className='col-12  '>
              <div className='card'>
                <div className='card-body'>
                  <input
                    type='text'
                    className='form-control search-width me-2 mb-2'
                    id='search'
                    name='search'
                    placeholder='Search Match'
                    style={{ width: '15%' }} 
                    autoComplete='off'
                  />
                  <div className='table-responsive'>
                    <table id='scroll-horizontal-datatable' className='table w-100 nowrap' >
                      <thead>
                        <tr>
                          <th>SN</th>
                          <th>Match Title</th>
                          <th>Tournament Name</th>
                          <th>Country</th>
                          <th>Date & Time</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody> 
                        <tr>
                          <td>1</td>
                          <td>IND vs PAK <br /> (India vs Pakistan)</td>
                          <td>Premier League</td>
                          <td>Afghanistan</td>
                          <td>2024-10-02 <br />13:30:00</td>
                          <td>
                              <span className="badge badge-success-lighten">
                                  ACTIVE
                              </span>
                          </td>
                          <td> 
                          <MdOutlineCircle
                              data-tooltip-id="active-match" data-tooltip-content="Active Match" 
                              className="jumbo-icon pointer text-success user-status fs-5 me-2" style={{ cursor: "pointer" }} 
                          />
                          <Tooltip id="active-match" place="bottom" effect="solid" />
                          </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <ReactPaginate
                    previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                    nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                    className='pagination'
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    // pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    // onPageChange={handlePageChange}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'pagination-active-page'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllMatch;
